export function isSpherical(cameraType) {
    return cameraType === "cubemap" || cameraType === "calotte";
}
export function isNotFrontViewingPerspective(cameraType, orientationOnVehicle) {
    return ((cameraType === "stereo" || cameraType === "mono") && !(orientationOnVehicle > -10 && orientationOnVehicle < 10));
}
//# sourceMappingURL=Geo.js.map